'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n        transform: rotate(45deg);\n        top: calc(100% - ', 'px);\n      '], ['\n        transform: rotate(45deg);\n        top: calc(100% - ', 'px);\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n        transform: rotate(135deg);\n        left: -', 'px;\n      '], ['\n        transform: rotate(135deg);\n        left: -', 'px;\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        transform: rotate(-135deg);\n        top: -', 'px;\n      '], ['\n        transform: rotate(-135deg);\n        top: -', 'px;\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        transform: rotate(-45deg);\n        left: calc(100% - ', 'px);\n      '], ['\n        transform: rotate(-45deg);\n        left: calc(100% - ', 'px);\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n        bottom: ', 'px;\n      '], ['\n        bottom: ', 'px;\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n        top: calc(50% - ', 'px);\n      '], ['\n        top: calc(50% - ', 'px);\n      ']),
    _templateObject7 = _taggedTemplateLiteral(['\n        top: ', 'px;\n      '], ['\n        top: ', 'px;\n      ']),
    _templateObject8 = _taggedTemplateLiteral(['\n        right: ', 'px;\n      '], ['\n        right: ', 'px;\n      ']),
    _templateObject9 = _taggedTemplateLiteral(['\n        left: calc(50% - ', 'px);\n      '], ['\n        left: calc(50% - ', 'px);\n      ']),
    _templateObject10 = _taggedTemplateLiteral(['\n        left: ', 'px;\n      '], ['\n        left: ', 'px;\n      ']),
    _templateObject11 = _taggedTemplateLiteral(['\n  position: absolute;\n  pointer-events: none;\n\n  border: ', ';\n  border-top-left-radius: 100%;\n  border-top-color: transparent !important;\n  border-left-color: transparent !important;\n  border-bottom-right-radius: ', ';\n\n  width: ', ';\n  height: ', ';\n  background-color: ', ';\n  ', ';\n  ', ';\n'], ['\n  position: absolute;\n  pointer-events: none;\n\n  border: ', ';\n  border-top-left-radius: 100%;\n  border-top-color: transparent !important;\n  border-left-color: transparent !important;\n  border-bottom-right-radius: ', ';\n\n  width: ', ';\n  height: ', ';\n  background-color: ', ';\n  ', ';\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Placement = require('./utils/Placement');

var _Use = require('./utils/Use');

var _PlacementConstants = require('./PlacementConstants');

var _Styles = require('../utils/Styles');

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var mediumArrowSize = 16;
var smallArrowSize = 12;

// To keep the logic behind shepherd arrows consistent since it can get tricky.
// If it is structured we know it needs a footer to be white. If unstructured, guess by placement.
var isShepherdArrowWhite = function isShepherdArrowWhite(placement, isStructured, hasStructuredHeader) {
  return isStructured && !hasStructuredHeader || !isStructured && placement.includes('top');
};

var getBackgroundColor = function getBackgroundColor(_ref) {
  var color = _ref.color,
      hasStructuredHeader = _ref.hasStructuredHeader,
      isStructured = _ref.isStructured,
      placement = _ref.placement,
      popoverUse = _ref.popoverUse;

  if (color) {
    return color;
  }

  if (popoverUse === 'shepherd') {
    return isShepherdArrowWhite(placement, isStructured, hasStructuredHeader) ? _colors.OLAF : _colors.THUNDERDOME;
  }
  return 'inherit';
};

var getSideStyles = function getSideStyles(_ref2) {
  var placement = _ref2.placement,
      width = _ref2.width;

  switch ((0, _Placement.getSide)(placement)) {
    case 'top':
      // Arrow points down
      return (0, _styledComponents.css)(_templateObject, width / 2);
    case 'right':
      // Arrow points left
      return (0, _styledComponents.css)(_templateObject2, width / 2);
    case 'bottom':
      // Arrow points up
      return (0, _styledComponents.css)(_templateObject3, width / 2);
    case 'left':
      // Arrow points right
      return (0, _styledComponents.css)(_templateObject4, width / 2);
    default:
      return '';
  }
};

var getEdgeStyles = function getEdgeStyles(_ref3) {
  var inset = _ref3.inset,
      placement = _ref3.placement,
      width = _ref3.width;

  // Magic calculation, haven't quite figured this out yet
  var adjustedInset = inset + 3;

  switch ((0, _Placement.getEdge)(placement)) {
    case 'top':
      // Arrow is near the bottom of the left or right side
      return (0, _styledComponents.css)(_templateObject5, adjustedInset);
    case 'middle':
      return (0, _styledComponents.css)(_templateObject6, width / 2);
    case 'bottom':
      // Arrow is near the top of the left or right side
      return (0, _styledComponents.css)(_templateObject7, adjustedInset);
    case 'left':
      // Arrow is near the right of the top or bottom side
      return (0, _styledComponents.css)(_templateObject8, adjustedInset);
    case 'center':
      return (0, _styledComponents.css)(_templateObject9, width / 2);
    case 'right':
      // Arrow is near the left of the top or bottom side
      return (0, _styledComponents.css)(_templateObject10, adjustedInset);

    default:
      return '';
  }
};

var getBorderUseStyles = function getBorderUseStyles(_ref4) {
  var isStructured = _ref4.isStructured,
      placement = _ref4.placement,
      popoverUse = _ref4.popoverUse;

  if (popoverUse === 'default' || popoverUse === 'longform') {
    return '1px solid ' + _colors.BATTLESHIP;
  }
  if (popoverUse === 'shepherd' && isShepherdArrowWhite(placement, isStructured)) {
    return '1px solid ' + _colors.BATTLESHIP;
  }
  return null;
};

var Arrow = _styledComponents2.default.div.withConfig({
  displayName: 'UIPopoverArrow__Arrow'
})(_templateObject11, getBorderUseStyles, function (_ref5) {
  var popoverUse = _ref5.popoverUse;
  return popoverUse === 'tooltip' || popoverUse === 'tooltip-danger' ? '3px' : null;
}, function (_ref6) {
  var width = _ref6.width;
  return (0, _Styles.toPx)(width);
}, function (_ref7) {
  var width = _ref7.width;
  return (0, _Styles.toPx)(width);
}, getBackgroundColor, getSideStyles, getEdgeStyles);

var UIPopoverArrow = function (_PureComponent) {
  _inherits(UIPopoverArrow, _PureComponent);

  function UIPopoverArrow() {
    _classCallCheck(this, UIPopoverArrow);

    return _possibleConstructorReturn(this, (UIPopoverArrow.__proto__ || Object.getPrototypeOf(UIPopoverArrow)).apply(this, arguments));
  }

  _createClass(UIPopoverArrow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          width = _props.width,
          rest = _objectWithoutProperties(_props, ['className', 'width']);

      if (width === 0) {
        return null;
      }

      return _react2.default.createElement(Arrow, _extends({}, rest, {
        className: (0, _classNames2.default)('uiPopoverArrow private-popover__arrow', className),
        width: width
      }));
    }
  }]);

  return UIPopoverArrow;
}(_react.PureComponent);

UIPopoverArrow.propTypes = {
  color: _react.PropTypes.string,
  hasStructuredHeader: _react.PropTypes.bool,
  hasStructuredFooter: _react.PropTypes.bool,
  inset: _react.PropTypes.number.isRequired,
  isStructured: _react.PropTypes.bool,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  popoverUse: _react.PropTypes.oneOf(Object.keys(_Use.USE_CLASSES)),
  width: _react.PropTypes.number
};

UIPopoverArrow.defaultProps = {
  hasStructuredHeader: false,
  hasStructuredFooter: false,
  inset: 0,
  isStructured: false,
  placement: 'top',
  width: 20
};

UIPopoverArrow.ARROW_SIZES = {
  none: {
    distance: 4,
    inset: 0,
    width: 0
  },
  medium: {
    distance: mediumArrowSize,
    inset: mediumArrowSize - 2,
    width: 20
  },
  small: {
    distance: smallArrowSize,
    inset: smallArrowSize - 2,
    width: 16
  }
};

UIPopoverArrow.displayName = 'UIPopoverArrow';

exports.default = UIPopoverArrow;
module.exports = exports['default'];